import { render, staticRenderFns } from "./FinalRewards.vue?vue&type=template&id=3072bf03&scoped=true&"
import script from "./FinalRewards.vue?vue&type=script&lang=js&"
export * from "./FinalRewards.vue?vue&type=script&lang=js&"
import style0 from "./FinalRewards.vue?vue&type=style&index=0&id=3072bf03&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3072bf03",
  null
  
)

export default component.exports